import React, { Component } from 'react';
import Layout from './hoc/Layout/Layout';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import asyncComponent from './hoc/asyncComponent/asyncComponent';
import uuid from 'react-native-uuid';
import AddOrder from './containers/Orders/AddOrder/AddOrder';
import Home from './containers/Home/Home';
import ShowOrders from './containers/Orders/ShowOrders/ShowOrders';
import Documents from './components/Documents/Documents';
import Deliveries from './containers/Deliveries/Deliveries';
import AddDelivery from './containers/Deliveries/AddDelivery/AddDelivery';
import AdminScoutSummary from './containers/adminScoutSummary/adminScoutSummary';
import Logout from './containers/Auth/Logout/Logout';
import * as actions from './store/actions/index';
import ReactInterval from 'react-interval';
import CallList from './containers/Orders/CallList/CallList';
import AdminCallList from './containers/Orders/AdminCallList/AdminCallList';
import ApproveOrders from './containers/Orders/ApproveOrders/ApproveOrders';
import AdminOrders from './containers/Orders/AdminOrders/AdminOrders';
import AdminOrder from './containers/Orders/AdminOrder/AdminOrder';
import PickupSummary from './containers/PickupSummary/PickupSummary';
import AdminPickup from './containers/AdminPickup/AdminPickup';
import Drivers from './containers/Drivers/Drivers';
import AddDriver from './containers/AddDriver/AddDriver';
import EditDriver from './containers/EditDriver/EditDriver';

const asyncAuth = asyncComponent(() => {
  return import('./containers/Auth/Auth');
});

const asyncAddOrder = asyncComponent(() => {
  return import('./containers/Orders/AddOrder/AddOrder');
});

class App extends Component {
  componentDidMount () {    
    this.props.onTryAutoSignup();   
    
 
      this.props.onTickOrdersSummary();
  }

  render () {
    let id = "0";
    let result = "";
      if (this.props.location.search.indexOf("?") > -1) {    
        let r = this.props.location.search.replace("?","");
        if (r.indexOf('&') > 0) {
          let x = r.split('&');
          id = x[0];
          result = x[1];
        }
        else if (isNaN(r)) {
          result = r;
        }
        else
        {
          id = r;
        }
      }

    let routes = (
      <Switch>
        <Route path="/auth" component={asyncAuth} />
        <Route path="/documents" component={Documents} />        
        <Route path="/" exact component={Home} />
        <Redirect to="/" />
      </Switch>
    );



    if ( this.props.isAuthenticated ) {
      routes = (
        <Switch>
          <Route path="/logout" component={Logout} />
          <Route path="/auth" component={asyncAuth} />
          <Route path="/deliveries" component={Deliveries} />
          <Route path="/addDelivery" render={props =><AddDelivery {...props} />} />
          <Route path="/addOrder" render={(props) => <AdminOrder {...props} mode='' saveMode='add' orderId={id} filteredUserId={result}/>} />
          <Route path="/editOrder" render={(props) => <AdminOrder {...props} mode='' saveMode='edit' orderId={id}filteredUserId={result}/>} />
          <Route path="/adminAddOrder" render={(props) => <AdminOrder {...props} mode='admin' saveMode='add' orderId={id} filteredUserId={result}/>} />
          <Route path="/adminEditOrder" render={(props) => <AdminOrder {...props} mode='admin' saveMode='edit' orderId={id} filteredUserId={result} />} />
          <Route path="/showOrders" render={(props) => <ShowOrders {...props} result={result} />} />
          <Route path="/callList" render={(props) => <CallList {...props} result={id} />} />
          <Route path="/adminCallList" render={(props) => <AdminCallList {...props} result={id} />} />
          <Route path="/drivers" render={(props) => <Drivers {...props} result={id} />} />
          <Route path="/addDriver" render={(props) => <AddDriver {...props} />} />
          <Route path="/adminEditDriver" render={(props) => <EditDriver {...props} />} />
          <Route path="/adminScoutSummary" render={(props) => <AdminScoutSummary {...props} />} />
          <Route path="/adminApprove" component={ApproveOrders}/>
          <Route path="/adminOrders" render={(props) => <AdminOrders {...props} filteredUserId={id}  result={result} />} />
          <Route path="/adminOrder"  render={(props) => <AdminOrder {...props} orderId={id} filteredUserId={result} />} />
          <Route path="/pickupSummary"  render={(props) => <PickupSummary {...props} filteredUserId={id} result={result} />} />
          <Route path="/adminPickup"  render={(props) => <AdminPickup {...props} filteredUserId={id} />} />
          <Route path="/documents" component={Documents} />
          <Route path="/" exact component={Home} />
          <Redirect to="/" />
        </Switch>
      );      
    }

    if (this.props.location.pathname == '/addDelivery') {
return(
  <div id='app' style={{"height":"100%"}}> 
  <AddDelivery editDeliveryId={id} id={uuid.v4()} />
  </div>
);
    }
    else {
    return (

      <div id='app' style={{"height":"100%"}}> 
       
  
        <Layout>
         {routes}
        </Layout>
      </div>
    
    )};
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.orders.token !== null
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch( actions.authCheckState() ),
    onTickOrdersSummary: () => dispatch(actions.tickOrdersSummary())
  };
};

export default withRouter( connect( mapStateToProps, mapDispatchToProps )( App ) );



// WEBPACK FOOTER //
// ./src/App.js